import { render, staticRenderFns } from "./WorkingPortfolioNew.vue?vue&type=template&id=d054d990&"
import script from "./WorkingPortfolioNew.vue?vue&type=script&lang=js&"
export * from "./WorkingPortfolioNew.vue?vue&type=script&lang=js&"
import style0 from "./WorkingPortfolioNew.vue?vue&type=style&index=0&id=d054d990&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports